import { scan, flattenItems } from "./scan.js";
import { ID_PREFIX, isComponentName } from "./schemas.js";
import { isValidId } from "./types.js";
function applyEdits(source, edits) {
    const sorted = [...edits].sort((a, b) => b.start - a.start);
    let out = source;
    for (const e of sorted)
        out = out.slice(0, e.start) + e.text + out.slice(e.end);
    return out;
}
/**
 * Give every heading a trailing `{#hN}` and every component fence an `id=` (inserted right
 * after the name). Valid supplied ids are kept; duplicates and invalid ids are renamed to the
 * lowest free `<prefix><n>`. Everything else is preserved byte for byte. Idempotent.
 */
export function assignIds(markdown) {
    const items = flattenItems(scan(markdown));
    const used = new Set();
    const pending = [];
    // Pass 1: reserve valid, unique ids (first occurrence wins).
    for (const item of items) {
        if (item.kind === "markdown")
            continue;
        const managed = item.kind === "heading" || isComponentName(item.name);
        if (isValidId(item.id) && !used.has(item.id)) {
            used.add(item.id);
            continue;
        }
        if (managed)
            pending.push({ item, from: item.id });
    }
    // Pass 2: assign the lowest unused number per prefix, in document order.
    const assigned = [];
    const renamed = [];
    const edits = [];
    for (const { item, from } of pending) {
        const prefix = item.kind === "heading" ? ID_PREFIX.heading : ID_PREFIX[item.name];
        let n = 1;
        while (used.has(`${prefix}${n}`))
            n++;
        const id = `${prefix}${n}`;
        used.add(id);
        if (from)
            renamed.push({ from, to: id });
        else
            assigned.push(item.kind === "heading" ? { id, kind: "heading" } : { id, kind: "component", name: item.name });
        if (item.kind === "heading") {
            if (item.markerSpan)
                edits.push({ ...item.markerSpan, text: ` {#${id}}` });
            else
                edits.push({ start: item.insertAt, end: item.insertAt, text: ` {#${id}}` });
        }
        else if (item.kind === "component") {
            if (item.idSpan)
                edits.push({ ...item.idSpan, text: `id=${id}` });
            else
                edits.push({ start: item.nameEnd, end: item.nameEnd, text: ` id=${id}` });
        }
    }
    return { markdown: edits.length ? applyEdits(markdown, edits) : markdown, assigned, renamed };
}
//# sourceMappingURL=ids.js.map